import data from './xrp'

const { productData, newsData, companyInfo,successData } = data

export { productData, newsData, companyInfo,successData }